import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Modal } from 'grab-ui';
import formatCurrency from 'common/utils/format-currency';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';

import style from './shopify-order-detail-modal.less';

const renderLineItem = item => (
  <div className={style.lineItemContainer} key={item.ID}>
    <div width="10%" className={style.lineItemQty}>
      {`${item.quantity}x`}
    </div>
    <div className={style.lineItemName}>{item.name}</div>
    <div className={style.lineItemPrice}>
      {formatCurrency({ code: item.currency, amount: item.subtotalPrice })}
    </div>
  </div>
);

const renderLineItemList = itemList => {
  if (itemList.length) {
    return itemList.map(item => renderLineItem(item));
  } else {
    return (
      <div className={style.lineItemContainer}>
        <center>No item found</center>
      </div>
    );
  }
};

export const ShopifyOrderDetailModal = ({ ctx, shopifyMetaData, contact }) => {
  ctx.fireShopifyTrackEvent({
    stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDER_NUMBER_ITEMS_WEB,
    eventName: SCRIBE_SHOPIFY_EVENTS.DEFAULT,
  });

  return Modal.info({
    width: '478px',
    title: (
      <div className={style.header}>
        <span className={style.orderTitle}>
          Shopify Order {shopifyMetaData.name}
        </span>
        <div className={style.orderContactContainer}>
          <div className={style}>{contact.name}</div>
          <span className={style.middleDot}>•</span>
          <div>{contact.phone}</div>
        </div>
      </div>
    ),
    className: style.modal,
    content: (
      <div>
        <Divider className={style.divider} />
        <div className={style.lineItemListContainer}>
          {renderLineItemList(shopifyMetaData.lineItems)}
        </div>
        <Divider className={style.divider} />
        <div className={style.custNoteContainer}>
          <span className={style.custNoteTitle}>Customer note</span>
          <p className={style.custNoteContent}>{shopifyMetaData.note}</p>
        </div>
      </div>
    ),
    okText: 'Close',
    onOk: () => {
      ctx.fireShopifyTrackEvent({
        stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDER_NUMBER_ITEMS_WEB,
        eventName: SCRIBE_SHOPIFY_EVENTS.CLOSE,
      });
    },
    onCancel: () => {
      ctx.fireShopifyTrackEvent({
        stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDER_NUMBER_ITEMS_WEB,
        eventName: SCRIBE_SHOPIFY_EVENTS.LEAVE,
      });
    },
    maskClosable: true,
    icon: null,
  });
};

ShopifyOrderDetailModal.propTypes = {
  shopifyMetaData: PropTypes.shape({}),
  contact: PropTypes.shape({}),
};

ShopifyOrderDetailModal.defaultProps = {
  shopifyMetaData: {},
  contact: {},
};

export default ShopifyOrderDetailModal;
